const WORKFLOW = `- uses: futuremoney/fargate-deployer@v1
  with:
    manifest: deploy/production.yaml
    role-to-assume: arn:aws:iam::111122223333:role/github-actions-deploy`;

export function Hero() {
  return (
    <header className="hero" id="overview">
      <span className="eyebrow">GitHub Action</span>
      <h1>Fargate Deployer</h1>
      <p className="lede">
        Deploy a container to AWS ECS Fargate from a single declarative manifest — a long-running
        service behind an Application Load Balancer, or a set of EventBridge-scheduled tasks.
      </p>

      <pre className="block">
        <code>{WORKFLOW}</code>
      </pre>

      <p className="lede small" style={{ marginTop: '1rem' }}>
        That one step builds your image, pushes it to ECR, deploys the stack, and waits until ECS
        reports the service healthy. Your repository needs a <code>Dockerfile</code> and a
        manifest — no CDK app required, no Node.js toolchain, no CloudFormation templates to
        write. If you <em>do</em> already have a CDK app,{' '}
        <a href="#construct-mode">import the stack into it</a> instead.
      </p>

      <p className="lede small">
        <strong>It deploys into a VPC, cluster and load balancer you already own</strong> — it does
        not create them. <a href="#prerequisites">What you need first ↓</a>
      </p>

      <div className="cta">
        <a className="btn btn-primary" href="#validator">
          Try the validator
        </a>
        <a className="btn" href="#quickstart">
          Quickstart
        </a>
        <a className="btn" href="https://github.com/FutureMoney/fargate-deployer">
          GitHub
        </a>
        <a className="btn" href="https://www.npmjs.com/package/fargate-deployer">
          npm
        </a>
        <a className="btn" href="https://github.com/marketplace/actions/fargate-deployer">
          Marketplace
        </a>
      </div>
    </header>
  );
}
